export default "__VITE_ASSET__Bhb4kTMj__"